import React, { useContext, useEffect, useState } from 'react';

import {
    Paper,
    Avatar,
    Table,
    TablePagination,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Link,
    Tooltip,
    IconButton,
    Switch,
    colors
} from '@material-ui/core';

import {
    ConfirmIconButton
} from '../../../../common';

import { PageContext } from '../PageContext';

import TableIcon from '@material-ui/icons/TableChartOutlined';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import PeopleIcon from '@material-ui/icons/People';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        overflow: 'hidden'
    },
    table: {
    },
    crudTable: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        marginRight: theme.spacing(1)
    },
    disabled: {
        color: colors.grey[500]
    },
    overlayContainer: {
        position: "relative"
    },
    overlay: {
        position: "absolute",
        top: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        opacity: ".7"
    }
}));

export const TableList = ({
    searchText,
    itemsPerPage,
    loading,
    disabled,
    onViewTable,
    onToggleAvailability,
    onToggleAllowImport,
    onToggleClearOnImport,
    onManageUsers,
    onLoadMore,
    ...props }) => {
    const classes = useStyles();

    const {
        state
    } = useContext(PageContext);

    const {
        bundle,
        tables
    } = state;

    const [pageIndex, setPageIndex] = useState(-1);
    const pageIndexChangeHandler = (e, index) => {
        setPageIndex(index);
    }

    const [pageSize, setPageSize] = useState(-1);
    const pageSizeChangeHandler = (e) => {
        setPageSize(e.target.value)
    }

    const viewTableClickHandler = (table) => {
        if (onViewTable) onViewTable(table);
    }

    const toggleAvailabilityClickHandler = (table) => {
        if (onToggleAvailability) onToggleAvailability(table);
    }

    const toggleAllowImportClickHandler = (table) => {
        if (onToggleAllowImport) onToggleAllowImport(table);
    }

    const toggleClearOnImportClickHandler = (table) => {
        if (onToggleClearOnImport) onToggleClearOnImport(table);
    }

    const manageUsersClickHandler = (table) => {
        if (onManageUsers) onManageUsers(table);
    }

    useEffect(() => {
        if ((pageIndex !== -1 || pageSize !== -1) && onLoadMore) {
            onLoadMore(searchText, Math.max(0, pageIndex), Math.max(itemsPerPage, pageSize));
        }
    }, [pageIndex, pageSize]);

    useEffect(() => {
        if (searchText !== null
            && searchText !== undefined
            && onLoadMore) {
            onLoadMore(searchText, 0, Math.max(itemsPerPage, pageSize));
        }
    }, [searchText]);

    return (
        <Paper className={classes.root}>
            <div className={classes.overlayContainer}>
                <TablePagination
                    component="div"
                    count={bundle ? bundle.totalItems : 0}
                    onPageChange={pageIndexChangeHandler}
                    onRowsPerPageChange={pageSizeChangeHandler}
                    page={Math.max(0, pageIndex)}
                    rowsPerPage={Math.max(itemsPerPage, pageSize)}
                    rowsPerPageOptions={[itemsPerPage / 2, itemsPerPage, itemsPerPage * 2]}
                />
                <Table className={classes.table} arial-label="tables list">
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ width: "60%" }}>Table Name</TableCell>
                            <TableCell style={{ width: "10%" }} align="center">Members</TableCell>
                            <TableCell style={{ width: "10%" }} align="center">Allow Import</TableCell>
                            <TableCell align="right"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tables && tables.map((table, index) =>
                            <TableRow hover key={index}>
                                <TableCell component="th" scope="row">
                                    <div className={classes.crudTable}>
                                        <Avatar
                                            aria-label="avatar"
                                            className={classes.avatar}>
                                            <TableIcon />
                                        </Avatar>
                                        <Link
                                            className={disabled ? classes.disabled : null}
                                            component="button"
                                            color="textSecondary"
                                            disabled={disabled}
                                            onClick={() => viewTableClickHandler(table)}>
                                            <Typography>
                                                {table.tableName}
                                            </Typography>
                                        </Link>
                                    </div>
                                </TableCell>
                                <TableCell align="center">
                                    {table.membersCount}
                                </TableCell>
                                <TableCell align="center">
                                    <Tooltip title={table.allowImport ? "Table allows data import" : "Table do not allow data import"}>
                                        <span>
                                            <Switch
                                                checked={table.allowImport}
                                                onChange={() => toggleAllowImportClickHandler(table)}
                                                name="allowImport"
                                                disabled={disabled}
                                                inputProps={{ "aria-label": "allow import checkbox" }}
                                            />
                                        </span>
                                    </Tooltip>
                                </TableCell>
                                <TableCell align="right">
                                    <ConfirmIconButton
                                        icon={table.isDisabled ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        tooltip={table.isDisabled ? "Enable this table for management" : "Disable this table from management"}
                                        disabled={disabled}
                                        onClick={() => toggleAvailabilityClickHandler(table)}
                                    />
                                    <Tooltip title="Manage users permissions">
                                        <span>
                                            <IconButton
                                                disabled={disabled}
                                                onClick={() => manageUsersClickHandler(table)}>
                                                <PeopleIcon />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={bundle ? bundle.totalItems : 0}
                    onPageChange={pageIndexChangeHandler}
                    onRowsPerPageChange={pageSizeChangeHandler}
                    page={Math.max(0, pageIndex)}
                    rowsPerPage={Math.max(itemsPerPage, pageSize)}
                    rowsPerPageOptions={[itemsPerPage / 2, itemsPerPage, itemsPerPage * 2]}
                />
                {loading && <div className={classes.overlay} />}
            </div>
        </Paper>
    );
}